import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UsersService } from '../../../../../models/usuarios.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent implements OnInit {
  public userImage = '../assets/img/users/user.jpg';
  user:any={};
  constructor(private usersService:UsersService,
     private router:Router) {

   }

  ngOnInit() {
    if (this.usersService.logado){
       this.user = this.usersService.usuario;
    }


  }

  logout(){
    this.usersService.logout();
    this.router.navigate(['/login']);
  
  }

}
